var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "container" }, [
    _c(
      "div",
      { staticClass: "breadcrumb" },
      [
        _c(
          "el-breadcrumb",
          { attrs: { "separator-class": "el-icon-arrow-right" } },
          [
            _c("el-breadcrumb-item", [
              _c("span", { staticStyle: { color: "#417ced" } }, [
                _vm._v("出库管理"),
              ]),
            ]),
            _c("el-breadcrumb-item", [_vm._v("内部出库退货")]),
          ],
          1
        ),
      ],
      1
    ),
    _c("div", { staticClass: "basic", staticStyle: { "margin-top": "15px" } }, [
      _c("p", { staticClass: "header" }, [_vm._v("订单信息")]),
      _c("ul", { staticClass: "ul" }, [
        _c("li", [
          _c("p", [_vm._v("订单编号：" + _vm._s(_vm.tableData.orderId))]),
          _c("p", [
            _vm._v(
              "订单状态： " +
                _vm._s(_vm.orderType[_vm.tableData.orderStatus - 1])
            ),
          ]),
          _c("p", [
            _vm._v("时 间 ：" + _vm._s(_vm.$moment(_vm.tableData.createdTime))),
          ]),
        ]),
        _c("li", [
          _c("span", [_vm._v("制单信息 ：")]),
          _c("span", [_vm._v(_vm._s(_vm.tableData.createdName))]),
        ]),
        _c("li", [
          _c("span", [_vm._v("收货信息 ：")]),
          _c("span", [_vm._v(_vm._s(_vm.tableData.consignee))]),
          _c("span", [_vm._v(_vm._s(_vm.tableData.receivingPhone))]),
          _c("span", [
            _vm._v(
              _vm._s(_vm.tableData.address + _vm.tableData.addressDetails)
            ),
          ]),
        ]),
        _c("li", [
          _c("span", [_vm._v("物流备注 ：")]),
          _c("span", [
            _vm._v(
              _vm._s(_vm.tableData.comment ? _vm.tableData.comment : "无")
            ),
          ]),
        ]),
        _c("div", { staticClass: "contentTemp" }, [
          _c("div", { staticClass: "fontTemp" }, [
            _c("p", [_vm._v("物流公司 : ")]),
            _c(
              "div",
              [
                _c(
                  "el-select",
                  {
                    attrs: {
                      placeholder: "快递公司",
                      filterable: "",
                      clearable: "",
                    },
                    model: {
                      value: _vm.logisticsCompany,
                      callback: function ($$v) {
                        _vm.logisticsCompany = $$v
                      },
                      expression: "logisticsCompany",
                    },
                  },
                  _vm._l(_vm.companys, function (itemsS) {
                    return _c("el-option", {
                      key: itemsS.dictName,
                      attrs: { label: itemsS.dictName, value: itemsS.dictName },
                    })
                  }),
                  1
                ),
              ],
              1
            ),
            _c(
              "div",
              [
                _c("el-input", {
                  attrs: { type: "text", placeholder: "请输入包裹物流单号" },
                  model: {
                    value: _vm.logistCode,
                    callback: function ($$v) {
                      _vm.logistCode = $$v
                    },
                    expression: "logistCode",
                  },
                }),
              ],
              1
            ),
          ]),
        ]),
      ]),
    ]),
    _c(
      "div",
      { staticClass: "goods" },
      [
        _c("p", { staticClass: "header" }, [_vm._v("商品详情")]),
        _c("span", [_vm._v(" 商品 ")]),
        _c(
          "el-table",
          {
            staticStyle: { width: "100%" },
            attrs: {
              data: _vm.tableData.interiorOrderCommodities,
              align: "center",
            },
          },
          [
            _c("el-table-column", {
              attrs: { label: "品牌", prop: "brandName" },
            }),
            _c("el-table-column", {
              attrs: { label: "商品名称", prop: "commodityName" },
            }),
            _c("el-table-column", {
              attrs: { label: "原订单数", prop: "number" },
            }),
            _c("el-table-column", {
              attrs: {
                label: "可退回数量",
                "min-width": "100px",
                prop: "waitNumber",
              },
            }),
            _c("el-table-column", {
              attrs: { label: "退货数量", "min-width": "195" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c(
                        "div",
                        [
                          _c(
                            "span",
                            { staticStyle: { "margin-right": "10px" } },
                            [_vm._v("正常")]
                          ),
                          _vm._v(" "),
                          _c("el-input-number", {
                            attrs: {
                              min: 0,
                              size: "mini",
                              max:
                                scope.row.number -
                                (scope.row.numberP + scope.row.numberL),
                            },
                            model: {
                              value: scope.row.numberY,
                              callback: function ($$v) {
                                _vm.$set(scope.row, "numberY", $$v)
                              },
                              expression: "scope.row.numberY",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        [
                          _c(
                            "span",
                            { staticStyle: { "margin-right": "10px" } },
                            [_vm._v("破损")]
                          ),
                          _vm._v(" "),
                          _c("el-input-number", {
                            attrs: {
                              max:
                                scope.row.number -
                                (scope.row.numberY + scope.row.numberL),
                              size: "mini",
                              min: 0,
                            },
                            model: {
                              value: scope.row.numberP,
                              callback: function ($$v) {
                                _vm.$set(scope.row, "numberP", $$v)
                              },
                              expression: "scope.row.numberP",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        [
                          _c(
                            "span",
                            { staticStyle: { "margin-right": "10px" } },
                            [_vm._v("漏件")]
                          ),
                          _vm._v(" "),
                          _c("el-input-number", {
                            attrs: {
                              min: 0,
                              size: "mini",
                              max:
                                scope.row.number -
                                (scope.row.numberY + scope.row.numberP),
                            },
                            model: {
                              value: scope.row.numberL,
                              callback: function ($$v) {
                                _vm.$set(scope.row, "numberL", $$v)
                              },
                              expression: "scope.row.numberL",
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", { attrs: { label: "单价", prop: "price" } }),
            _c("el-table-column", {
              attrs: { label: "规格", prop: "specificationName" },
            }),
            _c("el-table-column", {
              attrs: { label: "小计" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _vm._v(
                        " " + _vm._s(scope.row.price * scope.row.number) + " "
                      ),
                    ]
                  },
                },
              ]),
            }),
          ],
          1
        ),
        _c("span", [_vm._v(" 赠品 ")]),
        _c(
          "el-table",
          {
            staticStyle: { width: "100%" },
            attrs: {
              data: _vm.tableData.interiorOrderComplimentaries,
              align: "center",
            },
          },
          [
            _c("el-table-column", {
              attrs: { label: "品牌", prop: "brandName" },
            }),
            _c("el-table-column", {
              attrs: { label: "商品名称", prop: "commodityName" },
            }),
            _c("el-table-column", {
              attrs: { label: "原订单数", prop: "number" },
            }),
            _c("el-table-column", {
              attrs: {
                label: "可退回数量",
                "min-width": "100px",
                prop: "waitNumber",
              },
            }),
            _c("el-table-column", {
              attrs: { label: "退货数量", "min-width": "195" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c(
                        "div",
                        [
                          _c(
                            "span",
                            { staticStyle: { "margin-right": "10px" } },
                            [_vm._v("正常")]
                          ),
                          _vm._v(" "),
                          _c("el-input-number", {
                            attrs: {
                              min: 0,
                              size: "mini",
                              max:
                                scope.row.number -
                                (scope.row.numberP + scope.row.numberL),
                            },
                            model: {
                              value: scope.row.numberY,
                              callback: function ($$v) {
                                _vm.$set(scope.row, "numberY", $$v)
                              },
                              expression: "scope.row.numberY",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        [
                          _c(
                            "span",
                            { staticStyle: { "margin-right": "10px" } },
                            [_vm._v("破损")]
                          ),
                          _vm._v(" "),
                          _c("el-input-number", {
                            attrs: {
                              max:
                                scope.row.number -
                                (scope.row.numberY + scope.row.numberL),
                              size: "mini",
                              min: 0,
                            },
                            model: {
                              value: scope.row.numberP,
                              callback: function ($$v) {
                                _vm.$set(scope.row, "numberP", $$v)
                              },
                              expression: "scope.row.numberP",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        [
                          _c(
                            "span",
                            { staticStyle: { "margin-right": "10px" } },
                            [_vm._v("漏件")]
                          ),
                          _vm._v(" "),
                          _c("el-input-number", {
                            attrs: {
                              min: 0,
                              size: "mini",
                              max:
                                scope.row.number -
                                (scope.row.numberY + scope.row.numberP),
                            },
                            model: {
                              value: scope.row.numberL,
                              callback: function ($$v) {
                                _vm.$set(scope.row, "numberL", $$v)
                              },
                              expression: "scope.row.numberL",
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", { attrs: { label: "单价", prop: "price" } }),
            _c("el-table-column", {
              attrs: { label: "规格", prop: "specificationName" },
            }),
            _c("el-table-column", {
              attrs: { label: "小计" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _vm._v(
                        " " + _vm._s(scope.row.price * scope.row.number) + " "
                      ),
                    ]
                  },
                },
              ]),
            }),
          ],
          1
        ),
      ],
      1
    ),
    _c("div", { staticClass: "total" }, [
      _c("div", { staticClass: "before" }, [
        _c("p", [_vm._v("原单总计")]),
        _c("p", [_vm._v("共 " + _vm._s(_vm.orderCount()) + " 件")]),
        _c("p", [
          _vm._v(
            "运费：￥" + _vm._s(_vm.tableData.charge ? _vm.tableData.charge : 0)
          ),
        ]),
        _c("p", [_vm._v("赠品总价： ￥0")]),
        _c("p", [_vm._v("商品总价：￥" + _vm._s(_vm.tableData.total))]),
        _c("p", [_vm._v("应收金额：￥" + _vm._s(_vm.tableData.total))]),
        _c("p", [_vm._v("已收金额：￥" + _vm._s(_vm.tableData.receivedMoney))]),
        _c("p", [_vm._v("代收金额：￥0")]),
      ]),
      _c("div", { staticClass: "back" }, [
        _c("p", [_vm._v("仓库收货总计")]),
        _c("p", [_vm._v("正常" + _vm._s(_vm.totalCout(0)) + " 件")]),
        _c("p", [_vm._v("破损" + _vm._s(_vm.totalCout(1)) + " 件")]),
        _c("p", [_vm._v("漏件" + _vm._s(_vm.totalCout(2)) + " 件")]),
        _c("p", [_vm._v("已收货总价: " + _vm._s(_vm.totalCout(3)))]),
      ]),
    ]),
    _c("div", { staticClass: "notes" }, [
      _c("p", { staticClass: "header" }, [_vm._v("备注")]),
      _c(
        "div",
        [
          _c("el-input", {
            attrs: { type: "textarea", placeholder: "请输入需要备注信息....." },
            model: {
              value: _vm.textarea,
              callback: function ($$v) {
                _vm.textarea = $$v
              },
              expression: "textarea",
            },
          }),
        ],
        1
      ),
    ]),
    _c("div", { staticClass: "submit" }, [
      _c(
        "p",
        { staticStyle: { cursor: "pointer" }, on: { click: _vm.submintEvent } },
        [_vm._v("提交退货")]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }